import { createFileRoute } from '@tanstack/react-router'
import { ListCheck } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/sox-compliance')({
  staticData: {
    title: 'route.soxCompliance',
    crumb: 'route.soxCompliance',
    icon: ListCheck,
    permissions: ['sox_compliance_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
